export default __webpack_public_path__ + "static/media/028-traffic light.e96aac56.svg";